<template>
  <div class="total">
    <div style="height: 20px"></div>

    <div class="contentx">
      <div class="c-title">

         <img  class="c-img" :src="$store.state.baseurl + coversmail" alt />

        <div class="r-title">
          <div class="db-titile">{{ dbname }}</div>
          <!-- <div style="margin-top: 15px; color: #bb002f; font-size: 30px"> -->
            <div style="margin-top: 15px; margin-left: 5px; font-size: 20px">
            <!-- ￥{{ money }} -->
            收录条目：{{ resvol }}
          </div>
          <div class="c-title">
            <!-- <div style="margin-top: 5px; margin-right: 5px">时间:</div> -->
            <!-- <el-button
              size="medium"
              v-for="(item, i) in price"
              :key="item.ID"
              @click="setPrice(i)"
            >
              {{ item.duration }}
            </el-button> -->
          </div>
          <div class="c-title">
            <!-- <button class="btn-Jump1">联系购买</button> -->
            <button class="btn-Jump2" @click="goto(address)">进入</button>
          </div>
        </div>
      </div>

      <div style="height: 20px; background-color: #f0f0f0"></div>
      <div class="introduce-bac">
        <div class="line" style="margin-top: 30px">
          <span>产品介绍</span>
          <img src="../assets/line-1100.png" alt />
        </div>

        <div class="introduce">
          <div>商品名称： {{ dbname }}</div>
          <div>
            <span>上线时间：{{ online }}</span>
            <span style="margin-left:15px">产品形式：{{ shap }}</span>
          </div>
          <div>
            <!-- <span>收录年限：{{ included }}</span> -->
            <span >数据资源：{{ shperes }}</span>
          </div>
          <div>合作单位：{{ cooperation }}</div>
          <div>出版单位：{{ publish }}</div>
        </div>
        <hr width="1200px" style="border: 0.5px dashed #dadada" />
        <div class="introduce2">
          {{ introduce }}
        </div>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      id: '',
      dbname: '',
      price: [],
      money: '',
      address: '',
      online: '2000年',
      shap: '',
      included: '',
      shperes: '',
      cooperation: '-',
      publish: '广西师范大学出版社',
      introduce: '',
      resvol: '0',
      coversmail: require('../assets/database2.jpg'),
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.$http
      .get(`${this.$store.state.baseurl}/api/details?id=${this.id}`)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);
        this.dbname = obj.dbinfo.name;
        this.price = obj.dbinfo.price;
        this.money = obj.dbinfo.price[0].price;
        this.online = obj.dbinfo.online;
        this.shap = obj.dbinfo.shap;
        this.included = obj.dbinfo.included;
        this.shperes = obj.dbinfo.shperes;
        this.cooperation = obj.dbinfo.cooperation;
        this.publish = obj.dbinfo.publish;
        this.introduce = obj.dbinfo.introduce;
        this.address = obj.dbinfo.address;
        this.coversmail = obj.dbinfo.coversmail;
        this.resvol = obj.dbinfo.resvol;
        console.log(obj);
      });
    console.log(this.address);
  },
  methods: {
    setPrice(i) {
      this.money = this.price[i].price;
    },
    goto(ads) {
      console.log(this.address);
      window.location.href = this.address;
    },
  },

};
</script>

<style  scoped lang="scss">
.total {
  background-color: #f0f0f0;
}
.line {
  display: inline-block;
  padding: 0 15px 15px 15px;
  margin: 0 auto;
  width: 1200px;
  span {
    float: left;
    font-size: 19px;
    font-weight: 900;
    color: #497568;
  }
  img {
    float: left;
    margin-top: 14px;
    margin-left: 8px;
  }
  a {
    float: right;
    margin-top: -18px;
    margin-right: 4px;
    color: #888888;
    text-decoration: none;
    font-size: 10px;
  }
}
.contentx {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;

  .c-title {
    display: flex;
    margin-top: 15px;
    padding: 10px;
  }
  .c-img {
    width: 380px;
    height: 211px;
    margin-top: 18px;
  }
  .r-title {
    margin-left: 40px;
  }
  div {
    text-align: left;
  }
  .db-titile {
    font-size: 30px;
    padding: 5px;
  }
  bottom {
    border-radius: 0px;
  }
  .btn-Jump1 {
    width: 160px;
    height: 42px;
    margin-right: 20px;
    color: #4d776f;
    border: 1px solid #4d776f;
    background-color: #ffffff;
    border-radius: 5px;
  }
  .btn-Jump2 {
    width: 160px;
    height: 42px;
    color: #ffffff;
    border: 1px solid #921333;
    background-color: #921333;
    border-radius: 5px;
    margin-top: 40px;
  }
}
.introduce-bac {
  background-color: #ffffff;
  .introduce {
    padding-left: 36px;
    color: #707070;
    font-size: 13px;
    div {
      margin-top: 15px;
    }
  }
  .introduce2 {
    padding: 0 36px 15px 36px;
    margin-top: 15px;
    line-height: 25px;
    color: #707070;
    font-size: 13px;
  }
}
</style>
